import { React, useEffect } from "react";
import Chessground from "react-chessground";
import "react-chessground/dist/styles/chessground.css";
import "./Board.css";
import { useGlobalContext } from "../context";
import {
  fixBug,
  setChessboardColor,
} from "../helpers/chessboardHelperFunctions";

const BoardPrototype = () => {
  const { chessboardColor } = useGlobalContext();

  //fix bug from chessground library
  useEffect(() => {
    fixBug();
  });

  // set chessboard color
  useEffect(() => {
    setChessboardColor(chessboardColor);
  }, [chessboardColor]);

  return (
    <>
      <div className="board-section board-prototype">
        <Chessground
          width={550}
          height={550}
          viewOnly={true}
          fen={"rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"}
        />
      </div>
    </>
  );
};

export default BoardPrototype;
